import React from 'react'
import InlineSvg from 'svg-inline-react'

import colors from 'styles/colors'

const CloseButtonPadding = 10
const ContentPadding = 27

const CloseButton = ({ onClick }) => (
  <InlineSvg
    style={{ cursor: 'pointer', padding: CloseButtonPadding, width: 33, height: 33 }}
    element="div"
    onClick={onClick}
    src={require('!svg-inline?removeTags=true!images/icons/times-icon.svg')}
  />
)

export default ({ children, onClose }) => (
  <div
    className="flex-space-between"
    style={{
      height: 75,
      paddingLeft: ContentPadding,
      paddingRight: ContentPadding - CloseButtonPadding,
      borderBottom: `2px solid ${colors['color-navy-light']}`,
    }}
  >
    {children}
    {onClose && <CloseButton onClick={onClose}/>}
  </div>
)



// WEBPACK FOOTER //
// ./src/scripts/components/customer/EndUserAttributesCard/AttributesModal/ModalHeader/index.js